<template>
  <div style="margin: 100px;">
    Kmalu na Hitri račun...
  </div>
</template>

<script>
export default {
  created () {
    this.$emit('ready')
  }
}
</script>
